module.exports = __webpack_public_path__ + "img/latin-lawyer.726d90e7.png";